import React from 'react';
import { Box } from '@mui/material';
import { AssetronLogo } from '../logo';
import useAssetronHeaderStyles from './styles/useAssetronHeaderStyles';

function AssetronHeader() {
  const { headerDimensions, logoPadding } = useAssetronHeaderStyles();

  return (
    <Box sx={headerDimensions}>
      <Box sx={logoPadding}>
        <AssetronLogo />
      </Box>
    </Box>
  );
}

export default AssetronHeader;
